<template>
  <page>
    <span slot="page-title">Consulting</span>
    <p>The U.S. Election Modeling contained on this site is meant for public consumption. <a href="https://0ptimus.com/">0ptimus</a> works with clients to advise them on legislative risk in the U.S. as well as other countries around the world.</p>
    <p>If you would like to learn more about situation specific versions of this model or other legislative risk models around the world reach out to;</p>
    <p>
      <span>Inquiries for Publications: <a href="mailto:press@0ptimus.com" target="_blank">press@0ptimus.com</a></span>
      <br>
      <span>Inquires for Non-Publications: <a href="mailto:Elections@0ptimus.com" target="_blank">Elections@0ptimus.com</a></span>
    </p>
  </page>
</template>

<script>
import { Page } from '@/components'

const name = 'consulting'

const components = {
  Page
}

export default {
  name,
  components,
  metaInfo: {
    title: 'Consulting',
    meta: [
      {
        vmid: 'og:title',
        name: 'og:title',
        content: 'Consulting'
      }, {
        vmid: 'twitter:title',
        name: 'twitter:title',
        content: 'Consulting'
      }, {
        vmid: 'description',
        name: 'description',
        content: 'The U.S. Election Modeling contained on this site is meant for public consumption. Øptimus works with clients to advise them on legislative risk in the U.S. as well as other countries around the world.'
      }, {
        vmid: 'og:description',
        name: 'og:description',
        content: 'The U.S. Election Modeling contained on this site is meant for public consumption. Øptimus works with clients to advise them on legislative risk in the U.S. as well as other countries around the world.'
      }, {
        vmid: 'twitter:description',
        name: 'twitter:description',
        content: 'The U.S. Election Modeling contained on this site is meant for public consumption. Øptimus works with clients to advise them on legislative risk in the U.S. as well as other countries around the world.'
      }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Consulting.vue